import { Error, Cart, Shop, MobileProductDetail, AboutUs, Status } from './containers'

import { ROUTE_CONSTANTS } from './utils/constants'

const routes = [
	{
		path: ROUTE_CONSTANTS.BASE,
		exact: true,
		component: Cart,
		view: 'View All Marketplace Sellers',
		allowBack: false,
	},
	{
		path: ROUTE_CONSTANTS.CART,
		exact: true,
		component: Cart,
		view: 'Cart',
		allowBack: true,
	},
	{
		path: ROUTE_CONSTANTS.PRODUCT_DETAIL,
		exact: true,
		component: MobileProductDetail,
		view: 'Mobile Product Detail',
		allowBack: true,
	},
	{
		path: ROUTE_CONSTANTS.ERROR_PAGE,
		exact: true,
		component: Error,
		view: 'Error',
		allowBack: true,
	},
	{
		path: ROUTE_CONSTANTS.ABOUT_US,
		exact: false,
		component: AboutUs,
		view: 'About Us',
		allowBack: true,
	},
	{
		path: ROUTE_CONSTANTS.STATUS,
		exact: true,
		component: Status,
		view: 'Status',
		allowBack: false,
	},
	{
		path: ROUTE_CONSTANTS.PRIVACY_POLICY,
		exact: false,
		component: AboutUs,
		view: 'Privacy Policy',
		allowBack: true,
	},
	{
		path: ROUTE_CONSTANTS.ANY,
		exact: false,
		component: Shop,
		view: 'Shop',
		allowBack: true,
	},
]
export default routes
